import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  encrypt(text: string): string {
    const key = CryptoJS.enc.Base64.parse('BFF8Njl18p2z06n0hVbCM/VdSlzQNap6nmsfF40/qpE=');
    const iv = CryptoJS.enc.Base64.parse('pne9J14SW6K59LgV7Btafw==');
    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }}
